(() => {
  const bar = document.getElementById('skull-promo-bar');
  if (!bar || bar.dataset.initialized) return;
  const source = bar.querySelector('[data-skull-promo-bar-config]');
  let config;
  try { config = JSON.parse(source.textContent); } catch (_) { return; }
  bar.dataset.initialized = 'true';
  const root = document.documentElement;
  const spacer = document.querySelector('[data-skull-promo-bar-spacer]');
  const slots = [...bar.querySelectorAll('[data-bar-slot]')];
  const status = bar.querySelector('[data-bar-status]');
  const title = bar.querySelector('[data-bar-title]');
  const segments = [...bar.querySelectorAll('[data-bar-segment]')];
  const giftGroup = bar.querySelector('.skull-promo-bar__gifts');
  const benefits = [...bar.querySelectorAll('[data-bar-benefit]')];
  const cartButton = bar.querySelector('[data-bar-cart]');
  const cartCount = bar.querySelector('[data-bar-cart-count]');
  const clockFields = {
    hours: bar.querySelector('[data-bar-hours]'),
    minutes: bar.querySelector('[data-bar-minutes]'),
    seconds: bar.querySelector('[data-bar-seconds]')
  };
  const groupSize = Number(window.SKULL_OFFER?.groupSize || config.groupSize) || 5;
  const eligible = new Set(config.eligibleProductIds.map(Number));
  const excludedVariants = new Set([68074528473316, 68074549084388, 45998998290660, 49234202001636]);
  const lifecycle = new AbortController();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const watchedOverlays = new WeakSet();
  const clockFlips = new Map();
  const overlaySelector = 'dialog,.pvg-refined-modal,[class^="skull-pvg-modal-"],.header__drawer';
  let cart = window.__SKULL_CART || config.cart;
  let count = 0;
  let heroVisible = false;
  let clockState = null;
  let clockUnsubscribe;
  let resizeFrame = 0;
  let refreshTimer = 0;
  let visibilityFrame = 0;
  let requestController;
  let version = 0;
  let disposed = false;
  let suspended = false;
  let displayed = false;
  let cartSignature = '';
  let stylesheetReady = false;
  let firstClockRender = true;
  const unitOrderStorageKey = 'skull-promo-bar-unit-order-v1';
  let unitOrder = (() => {
    try {
      const stored = JSON.parse(sessionStorage.getItem(unitOrderStorageKey) || '[]');
      return Array.isArray(stored) ? stored.filter(key => typeof key === 'string').slice(-200) : [];
    } catch (_) { return []; }
  })();

  const text = (key, values = {}) => String(config.copy[key] || '').replace(/__(\w+)__/g, (token, name) => String(values[name.toLowerCase()] ?? token));
  const isGift = item => ['true', '1', true, 1].includes(item.properties?._skull_gift) || ['true', '1', true, 1].includes(item.properties?._skull_auto_gift);
  const eligibleLines = data => (data?.items || []).filter(item => eligible.has(Number(item.product_id)) && !excludedVariants.has(Number(item.variant_id)) && !isGift(item) && item.properties?._tipo !== 'Seguro de envío' && !item.properties?._skull_mystery_offer && item.properties?._upsell !== 'Mistery Box');
  // Match the header/native cart count: paid items count; insurance and automatic gifts do not.
  const visibleCartCount = data => (data?.items || [])
    .filter(item => !excludedVariants.has(Number(item.variant_id)))
    .reduce((total, item) => total + Math.max(0, Math.floor(Number(item.quantity) || 0)), 0);
  const lineIdentity = item => String(item.key || `${item.variant_id}:${JSON.stringify(item.properties || {})}`);

  function orderedEligibleUnits(lines) {
    const itemsByKey = new Map();
    const quantities = new Map();
    for (const item of lines) {
      const key = lineIdentity(item);
      itemsByKey.set(key, item);
      quantities.set(key, (quantities.get(key) || 0) + Math.max(0, Math.floor(Number(item.quantity) || 0)));
    }

    // Keep surviving units in their prior order. A lower quantity removes the
    // newest matching units; a higher quantity is appended as the newest add.
    const kept = new Map();
    const nextOrder = [];
    for (const key of unitOrder) {
      const limit = quantities.get(key) || 0;
      const used = kept.get(key) || 0;
      if (used >= limit) continue;
      nextOrder.push(key);
      kept.set(key, used + 1);
    }

    // Shopify returns newer cart lines first. Reverse only the missing lines so
    // initial hydration and multi-line additions become oldest -> newest.
    for (const item of [...lines].reverse()) {
      const key = lineIdentity(item);
      const missing = (quantities.get(key) || 0) - (kept.get(key) || 0);
      for (let index = 0; index < missing; index++) nextOrder.push(key);
      kept.set(key, quantities.get(key) || 0);
    }

    unitOrder = nextOrder.slice(-200);
    try {
      if (unitOrder.length) sessionStorage.setItem(unitOrderStorageKey, JSON.stringify(unitOrder));
      else sessionStorage.removeItem(unitOrderStorageKey);
    } catch (_) {}
    return { units: unitOrder, itemsByKey };
  }

  function stopClockFlips() {
    for (const cleanup of clockFlips.values()) cleanup();
  }

  function updateClockField(field, value) {
    if (!field) return;
    const previous = field.firstChild?.textContent || field.textContent;
    if (previous === value) return;
    clockFlips.get(field)?.();
    field.textContent = value;
    if (firstClockRender || reducedMotion.matches || document.hidden || !field.animate) return;
    const half = (name, content) => {
      const layer = document.createElement('span');
      layer.className = `skull-promo-bar__flap skull-promo-bar__flap--${name}`;
      layer.setAttribute('aria-hidden', 'true');
      const face = document.createElement('span');
      face.textContent = content;
      layer.append(face);
      field.append(layer);
      return layer;
    };
    const baseLayer = half('base', previous);
    const topLayer = half('top', previous);
    const bottomLayer = half('bottom', value);
    const outgoing = topLayer.animate([{ transform: 'rotateX(0deg)' }, { transform: 'rotateX(-90deg)' }], { duration: 210, easing: 'ease-in', fill: 'forwards' });
    const incoming = bottomLayer.animate([{ transform: 'rotateX(90deg)' }, { transform: 'rotateX(0deg)' }], { duration: 250, delay: 210, easing: 'ease-out', fill: 'both' });
    const cleanup = () => {
      outgoing.cancel();
      incoming.cancel();
      baseLayer.remove();
      topLayer.remove();
      bottomLayer.remove();
      if (clockFlips.get(field) === cleanup) clockFlips.delete(field);
    };
    clockFlips.set(field, cleanup);
    Promise.all([outgoing.finished, incoming.finished]).then(cleanup, cleanup);
  }

  function updateSpace() {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      const height = displayed ? Math.ceil(bar.getBoundingClientRect().height + (parseFloat(getComputedStyle(bar).bottom) || 0)) : 0;
      root.style.setProperty('--skull-promo-bar-height', `${height}px`);
    });
  }

  function setVisible(visible) {
    if (displayed === visible) return;
    displayed = visible;
    bar.hidden = !visible;
    if (spacer) spacer.hidden = !visible;
    document.body.classList.toggle('skull-promo-bar-visible', visible);
    updateSpace();
  }

  function keyboardIsOpen() {
    const active = document.activeElement;
    if (active instanceof Element && active.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]),textarea,select,[contenteditable="true"]')) return true;
    return !!window.visualViewport && window.visualViewport.height < window.innerHeight * .72;
  }

  function updateVisibility() {
    visibilityFrame = 0;
    if (disposed) return;
    const unlocked = window.SKULL_SLOT_GATE ? window.SKULL_SLOT_GATE.isUnlocked() : root.dataset.skullPromo !== 'locked';
    // Hidden UI should not force a full-page style recalculation every clock tick.
    if (!unlocked || !clockState || clockState.expired || heroVisible || document.hidden || suspended || keyboardIsOpen()) {
      setVisible(false);
      return;
    }
    const overlay = document.querySelector('dialog[open],.pvg-refined-modal.active,[class^="skull-pvg-modal-"].active,.header__drawer[open]');
    const busy = document.body.classList.contains('skull-hero-visible') || document.body.classList.contains('native-cart-open') || document.body.classList.contains('promo-popup-open');
    if (overlay || busy) { setVisible(false); return; }
    stylesheetReady ||= getComputedStyle(bar).position === 'fixed';
    setVisible(stylesheetReady);
  }

  function scheduleVisibility() {
    if (!visibilityFrame && !disposed) visibilityFrame = requestAnimationFrame(updateVisibility);
  }

  function watchOverlays(container = document) {
    const nodes = [...(container instanceof Element && container.matches(overlaySelector) ? [container] : []), ...container.querySelectorAll(overlaySelector)];
    for (const node of nodes) {
      if (watchedOverlays.has(node)) continue;
      watchedOverlays.add(node);
      overlayObserver.observe(node, { attributes: true, attributeFilter: ['open', 'class', 'hidden'] });
    }
  }

  function imageUrl(item) {
    const value = window.SKULL_VARIANT_IMAGES?.[String(item.variant_id)] || item.image || item.featured_image?.url;
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      url.searchParams.set('width', '112');
      return url.href;
    } catch (_) { return ''; }
  }

  function renderCart(data) {
    if (!Array.isArray(data?.items)) return;
    cart = data;
    const lines = eligibleLines(data);
    const ordered = orderedEligibleUnits(lines);
    count = ordered.units.length;
    const base = Math.floor(count / groupSize) * groupSize;
    const goal = base + groupSize;
    const filled = Math.max(0, count - base);
    const offer = `${goal}×${goal / groupSize}`;
    const itemCount = visibleCartCount(data);
    if (cartCount) cartCount.textContent = itemCount > 99 ? '99+' : String(itemCount);
    if (cartButton) cartButton.setAttribute('aria-label', text('cartCount', { count: itemCount }));
    const benefitPlan = count < groupSize ? [] : count < groupSize * 2 ? ['cap'] : ['thermo'];
    if (giftGroup) giftGroup.hidden = !benefitPlan.length;
    for (const benefit of benefits) {
      const type = benefit.dataset.barBenefit;
      benefit.hidden = !benefitPlan.includes(type);
      const earned = type === 'cap' ? count >= 8 : count >= 12;
      benefit.classList.toggle('is-earned', earned);
    }
    const signature = JSON.stringify(ordered.units.map(key => {
      const item = ordered.itemsByKey.get(key);
      return [key, item?.image, item?.product_title, item?.variant_title, imageUrl(item)];
    }));
    if (signature !== cartSignature) {
      cartSignature = signature;
      title.textContent = text(count === 0 ? 'startTitle' : count < groupSize ? 'completeTitle' : 'upgradeTitle', { offer });
      status.textContent = count === 0 ? text('addFirst') : text('addMore', { remaining: goal - count, paid: goal / groupSize });
      segments.forEach((segment, index) => segment.classList.toggle('is-on', index < filled));
      // Show the active five-unit group in the exact order each unit was added.
      const visibleItems = ordered.units.slice(base, base + groupSize).map(key => ordered.itemsByKey.get(key));
      slots.forEach((slot, index) => {
        const item = visibleItems[index];
        const number = base + index + 1;
        const identity = item ? `${item.key}:${number}:${imageUrl(item)}` : `empty:${number}`;
        slot.toggleAttribute('data-next', !item && index === filled);
        if (slot.dataset.identity === identity) return;
        const changed = !!slot.dataset.identity;
        slot.dataset.identity = identity;
        slot.toggleAttribute('data-filled', !!item);
        const name = item ? [item.product_title || item.title, item.variant_title !== 'Default Title' ? item.variant_title : ''].filter(Boolean).join(' · ') : '';
        if (item) slot.setAttribute('aria-label', text('slotFilled', { number, name }));
        else slot.removeAttribute('aria-label');
        slot.replaceChildren();
        const tile = document.createElement('span');
        tile.className = 'skull-promo-bar__tile';
        const url = item && imageUrl(item);
        const fallback = document.createElement('span');
        fallback.className = 'skull-promo-bar__placeholder';
        fallback.setAttribute('aria-hidden', 'true');
        fallback.textContent = item ? '✓' : '+';
        if (url) {
          const image = new Image(44, 43);
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.src = url;
          image.addEventListener('error', () => image.replaceWith(fallback), { once: true });
          tile.append(image);
        } else tile.append(fallback);
        if (item) slot.append(tile);
        else {
          const choice = document.createElement('a');
          choice.className = 'skull-promo-bar__choice';
          choice.dataset.barChoice = '';
          choice.href = `${config.rootUrl}#shop`;
          choice.setAttribute('aria-label', text('chooseSlot', { number }));
          choice.append(tile);
          slot.append(choice);
        }
        if (changed && displayed && item && !reducedMotion.matches) {
          slot.animate([{ opacity: .4, transform: 'translateY(4px) scale(.94)' }, { opacity: 1, transform: 'none' }], { duration: 230, easing: 'ease-out' });
        }
      });
    }
    scheduleVisibility();
  }

  function acceptCart(data) {
    if (!Array.isArray(data?.items)) return;
    version++;
    requestController?.abort();
    requestController = null;
    clearTimeout(refreshTimer);
    renderCart(data);
  }

  async function refreshCart() {
    clearTimeout(refreshTimer);
    if (disposed || suspended || document.hidden) return;
    requestController?.abort();
    const controller = new AbortController();
    requestController = controller;
    const ticket = ++version;
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(`${config.rootUrl}cart.js`, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) return;
      const data = await response.json();
      if (ticket === version && !disposed) renderCart(data);
    } catch (_) {
      // Keep the last confirmed cart. The bar never blocks add or checkout.
    } finally {
      clearTimeout(timeout);
      if (requestController === controller) requestController = null;
    }
  }

  function connectClock() {
    clockUnsubscribe?.();
    clockUnsubscribe = window.SKULL_PROMO_CLOCK?.subscribe(state => {
      const visibilityChanged = !clockState || clockState.expired !== state.expired;
      clockState = state;
      const remaining = Math.max(0, Math.ceil(state.remainingMs / 1000));
      const values = {
        hours: Math.floor(remaining / 3600),
        minutes: Math.floor(remaining % 3600 / 60),
        seconds: remaining % 60
      };
      for (const [name, field] of Object.entries(clockFields)) {
        updateClockField(field, String(values[name]).padStart(2, '0'));
      }
      firstClockRender = false;
      if (visibilityChanged) scheduleVisibility();
    });
  }

  const overlayObserver = new MutationObserver(scheduleVisibility);
  const stateObserver = new MutationObserver(scheduleVisibility);
  stateObserver.observe(root, { attributes: true, attributeFilter: ['data-skull-promo'] });
  stateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  const sectionsObserver = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node instanceof Element && !bar.contains(node)) watchOverlays(node);
    }
    scheduleVisibility();
  });
  sectionsObserver.observe(document.body, { childList: true });
  const resizeObserver = new ResizeObserver(updateSpace);
  resizeObserver.observe(bar);
  const hero = document.querySelector('#campaign');
  let heroObserver;
  if (hero && 'IntersectionObserver' in window) {
    const rect = hero.getBoundingClientRect();
    heroVisible = rect.bottom > 1 && rect.top < window.innerHeight;
    heroObserver = new IntersectionObserver(entries => {
      heroVisible = entries.some(entry => entry.isIntersecting);
      scheduleVisibility();
    }, { threshold: 0 });
    heroObserver.observe(hero);
  }
  watchOverlays();
  bar.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('[data-bar-cart]')) {
      event.preventDefault();
      if (typeof window.SKULL_NATIVE_OPEN === 'function') {
        window.SKULL_NATIVE_OPEN();
        return;
      }
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"],.open-cart,.header-actions__action.action__cart');
      if (trigger instanceof HTMLElement) trigger.click();
      else location.assign(config.cartUrl || `${config.rootUrl}cart`);
      return;
    }
    const choice = event.target instanceof Element && event.target.closest('[data-bar-choice]');
    if (!choice || config.pageType !== 'index' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const catalog = document.querySelector('#shop,.skull-live-shop');
    if (!catalog) return;
    event.preventDefault();
    catalog.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'start' });
  }, { signal: lifecycle.signal });
  reducedMotion.addEventListener('change', stopClockFlips, { signal: lifecycle.signal });
  document.addEventListener('skull:cart-synced', event => acceptCart(event.detail?.cart), { signal: lifecycle.signal });
  for (const name of ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh']) {
    document.addEventListener(name, event => {
      if (Array.isArray(event.detail?.cart?.items)) acceptCart(event.detail.cart);
      else {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(refreshCart, 350);
      }
    }, { signal: lifecycle.signal });
  }
  document.addEventListener('skull:promo-unlocked', scheduleVisibility, { signal: lifecycle.signal });
  document.addEventListener('shopify:section:load', event => { watchOverlays(event.target); scheduleVisibility(); }, { signal: lifecycle.signal });
  document.addEventListener('focusin', scheduleVisibility, { signal: lifecycle.signal });
  document.addEventListener('focusout', scheduleVisibility, { signal: lifecycle.signal });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopClockFlips();
    scheduleVisibility();
    if (!document.hidden) {
      clearTimeout(refreshTimer);
      // The shared cart service normally publishes first; fetch only as a fallback.
      refreshTimer = setTimeout(refreshCart, 700);
    }
  }, { signal: lifecycle.signal });
  window.visualViewport?.addEventListener('resize', scheduleVisibility, { signal: lifecycle.signal });
  window.addEventListener('resize', scheduleVisibility, { signal: lifecycle.signal });
  window.addEventListener('load', scheduleVisibility, { once: true, signal: lifecycle.signal });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    suspended = false;
    connectClock();
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCart, 700);
    scheduleVisibility();
  }, { signal: lifecycle.signal });
  window.addEventListener('pagehide', event => {
    suspended = true;
    clockUnsubscribe?.();
    stopClockFlips();
    requestController?.abort();
    clearTimeout(refreshTimer);
    cancelAnimationFrame(visibilityFrame);
    cancelAnimationFrame(resizeFrame);
    visibilityFrame = 0;
    resizeFrame = 0;
    if (event.persisted) return;
    disposed = true;
    lifecycle.abort();
    stateObserver.disconnect();
    overlayObserver.disconnect();
    sectionsObserver.disconnect();
    resizeObserver.disconnect();
    heroObserver?.disconnect();
  }, { signal: lifecycle.signal });
  renderCart(cart);
  connectClock();
  updateVisibility();
})();
